import { ActionIcon, Code, CopyButton, Paper, Text, Tooltip, rem } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';

// TODO Remove CognitoKey from the protected routes
function CognitoKey() {
  const [idToken, setIdToken] = useState('');

  const getIdToken = async () => {
    try {
      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken;
      return idToken;
    } catch (e) {
      console.log('error getting id token:', e);
      throw e;
    }
  };

  useEffect(() => {
    getIdToken().then((token) => {
      setIdToken(token?.toString() || '<none>');
    });
  }, []);

  return (
    <Paper shadow="sm" withBorder p="xl" h={rem(200)} w={rem(600)} m={rem(30)}>
      <Text component="div" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        <Code style={{ flexGrow: 1 }}>
          {idToken}
          <CopyButton value={idToken} timeout={2000}>
            {({ copied, copy }) => (
              <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="right">
                <ActionIcon color={copied ? 'teal' : 'gray'} variant="subtle" onClick={copy}>
                  {copied ? (
                    <IconCheck style={{ width: rem(16) }} />
                  ) : (
                    <IconCopy style={{ width: rem(16) }} />
                  )}
                </ActionIcon>
              </Tooltip>
            )}
          </CopyButton>
        </Code>
      </Text>
    </Paper>
  );
}

export { CognitoKey };
